var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._t("title")], 2),
      _c(
        "w-card-content",
        {
          style: { overflow: "hidden", flexGrow: 1 },
          attrs: { "no-padding": "" },
        },
        [
          _c("app-apex-chart", {
            ref: "chart",
            attrs: {
              height: "100%",
              type: _vm.chartType,
              options: _vm.chartOptions,
              series: _vm.displayData,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }